// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import translate from "@insite/client-framework/Translate";
import { SectionTitleStyles } from "@mcmc/App/Widgets/SectionTitleWidget/SectionTitleWidget";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

const sectionTitle: SectionTitleStyles = {
    title: {
        css: css`
            .title-slash {
                display: none;
            }
        `,
    },
};

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return createWidgetElement("SectionTitleWidget/SectionTitleWidget", {
        fields: {
            title: heading,
            links: viewAllUrl
                ? [
                      {
                          fields: {
                              destination: { type: "Url", value: viewAllUrl },
                              overriddenTitle: translate("View All"),
                          },
                      },
                  ]
                : [],
        },
        extendedStyles: sectionTitle,
    } as any);
};

export default CardListHeading;
